module.exports = __webpack_public_path__ + "img/77bd2807319e0e21b455c5b8e69bfb36.png";